module.exports = __webpack_public_path__ + "img/notification.e2a4e486.svg";